import React, { useEffect, useState } from "react";
import { createStyles, makeStyles } from '@mui/styles';
import {
    DataGridPremium,
    GridColDef,
    GridRowsProp,
    GridRowSelectionModel,
    useGridApiRef,
    GridGroupNode,
    GRID_ROOT_GROUP_ID,
    GridCellSelectionModel,
    GridFilterModel,
    GridLogicOperator,
    GridRowModel,
    GridToolbar,
    GridRowClassNameParams,
    GridTreeNode
} from '@mui/x-data-grid-premium';
import { createTheme, darken, lighten } from '@mui/material/styles';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { Button, Checkbox } from "@mui/joy";
import ImageIcon from '@mui/icons-material/Image';
import { sub } from "date-fns";
import { set } from "lodash";
import BlockIcon from '@mui/icons-material/Block';
import UploadIcon from '@mui/icons-material/Upload';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ImageUploadModal from "./components/imageuploadmodal";
import ImageModal from "../use/imagemodal";
import { Autocomplete, Backdrop, CircularProgress, InputAdornment, TextField, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { CheckCircle } from "@mui/icons-material";
import { GridCellParams } from "@mui/x-data-grid";
import RequestChange from "./components/requestChange";
import EditIcon from '@mui/icons-material/Edit';
import totalLocationData from "../../../data/locationdata";
import ImageModal2 from "../use/imagemodal2";




const defaultTheme = createTheme();
const useStyles2 = makeStyles(
    (theme) => {
        const getBackgroundColor = (color: any) =>
            theme.palette.mode === 'dark' ? darken(color, 0.6) : lighten(color, 0.6);

        const getHoverBackgroundColor = (color: any) =>
            theme.palette.mode === 'dark' ? darken(color, 0.5) : lighten(color, 0.5);

        return {
            root: {
                '& .completed': {
                    backgroundColor: getBackgroundColor(theme.palette.info.main),
                    '&:hover': {
                        backgroundColor: getHoverBackgroundColor(theme.palette.info.main),
                    },
                },
                '& .super-app-theme--Filled': {
                    backgroundColor: getBackgroundColor(theme.palette.success.main),
                    '&:hover': {
                        backgroundColor: getHoverBackgroundColor(theme.palette.success.main),
                    },
                },
                '& .super-app-theme--확인': {
                    backgroundColor: getBackgroundColor(theme.palette.warning.main),
                    '&:hover': {
                        backgroundColor: getHoverBackgroundColor(theme.palette.warning.main),
                    },
                },
                '& .super-app-theme--미확인': {
                    backgroundColor: getBackgroundColor(theme.palette.error.main),
                    '&:hover': {
                        backgroundColor: getHoverBackgroundColor(theme.palette.error.main),
                    },
                },
                '& .duplicate': {
                    color : "#ff7f00"
                },
                '& .completed2': {
                    color : "#1b49af"
                },
                '& .autoinput': {
                    color : "rgba(0, 0, 0, 0.26)"
                },
            },
        };
    },
    { defaultTheme },
);



const seatExample : any= [];

for (let i = 1; i <= 299; i++) {
    seatExample.push({ value: `${i}`, label: `${i}번` });
}



const Change: React.FC<any> = (props) => {
    const classes = useStyles2();
    const apiRef = useGridApiRef();



    const [selectedRow, setSelectedRow] = useState<any>();



    const [disabled, setDisabled] = useState(false);
    const [disabled3, setDisabled3] = useState(false);

    const [deleteBtnLoading, setDeleteBtnLoading] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const [rows, setRows] = useState<any>([]);

    const [imageUploadModalOpen, setImageUploadModalOpen] = useState(false);

    const [forImageUploadSelectedId, setForImageUploadSelectedId] = useState();

    const handleImageUploadModalClose = () => {
        setImageUploadModalOpen(false);
    }

    const [open3, setOpen3] = useState(false);
    const [imageSrc, setImageSrc] = useState("");
    const [searchText, setSearchText] = useState("");

    const [alignment, setAlignment] = useState("incomplete");
    const [alignment2, setAlignment2] = useState("total");

    const [loading1, setLoading1] = useState(false);
    const [selectedUser, setSelectedUser] = useState<any>(null);
    const [users, setUsers] = useState<any>([]);

    const [filterModel, setFilterModel] = useState<GridFilterModel>({
        items: [
            {
                id: 1,
                field: "name",
                operator: "contains",
                value: ""
            },
            {
                id: 2,
                field: "justForFilter",
                operator: "contains",
                value: "미완료"
            },
            {
                id : 3,
                field : "location",
                operator : "isAnyOf",
                value : [""]
            }
        ]
    });

    const [columns, setColumns] = useState<GridColDef[]>(
        [
            { field: 'name', headerName: '이름', width: 100, filterable: true, editable: false },
            { field: 'location', headerName: '기존지점', width: 100, filterable: true, editable: false
            },
            {
              field : "afterLocation", headerName : "이동할 지점", width : 100, filterable : true, editable : true, type : "singleSelect", valueOptions :
                [...totalLocationData.filter((each) => {
                    if(each.english === "total"){
                        return false;
                    }
    
                    if(!props.user){
                        return true;
                    }
    
                    if(each.academy.includes(props.user.academy)){
                        return true;
                    }
    
                    return true;
                }).map((each) => {
    
                    return {
                        value : each.korean,
                        label : each.korean
                    }
                })]
            },
            { field: 'createdAt', headerName: '생성일', width: 100, filterable: true, editable: false },
            { field: 'etc', headerName: "특이사항", width: 100, editable : true , sortable : false, renderCell : (params) => { 

                if(params.value){
                    return (
                        <div>
                            {params.value}
                        </div>
                    )
                }else{

                    //정가운데에 edit icon 넣기
                    return (
                        <div style={{display : "flex", alignItems : "center", justifyContent : "center"}}>
                            <EditIcon color="disabled" />
                        </div>
                    )
                }
            }},
            { field : "previousSeat", headerName : "기존 좌석", width : 100, filterable : true, editable : false},
            {
                field: "afterSeat", width: 150, headerName: "이동할 좌석", type: 'singleSelect', valueOptions: seatExample, editable: true, sortable: false
            },
            {
                field: 'seatPhoto', headerName: '기존 좌석 청소 사진', width: 150, filterable: true, sortable : false, renderCell: (params) => {

                    const id = params.row.id;
                    const userId = params.row.userId;

                    if (params.value) {

                        return (
                            <div
                                onClick={(e: any) => {

                                    setImageSrc(params.value);
                                    setOpen3(true);

                                }}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "100%",
                                    height: "100%",
                                    cursor: "pointer"
                                }}>
                                <ImageIcon color="success" />
                            </div>
                        )

                    } else {
                        return (
                            <div style={{
                                color : "red"
                            }}>
                                ⨉
                            </div>
                        )
                    }

                }
            },
            {
                field: "afterSeatOwner", width: 150, headerName: "이동할 좌석 주인", type: 'singleSelect', sortable: false
            },
            { field : "exitSeatDate", headerName : "이동할 좌석 비워지는 시간", width : 180, editable : true, sortable : false, renderCell : (params) => { 

                if(params.value){
                    return (
                        <div>
                            {params.value}
                        </div>
                    )
                }else{

                    //정가운데에 edit icon 넣기
                    return (
                        <div style={{display : "flex", alignItems : "center", justifyContent : "center"}}>
                            <EditIcon color="disabled" />
                        </div>
                    )
                }
            }},
            { field : "movingDate", headerName : "짐 옮길 시간", width : 180, editable : true, sortable : false, renderCell : (params) => { 

                if(params.value){
                    return (
                        <div>
                            {params.value}
                        </div>
                    )
                }else{

                    //정가운데에 edit icon 넣기
                    return (
                        <div style={{display : "flex", alignItems : "center", justifyContent : "center"}}>
                            <EditIcon color="disabled" />
                        </div>
                    )
                }
            }},
            {
                field: 'tellStudent', headerName: '학생에게 전달하기', width: 120, sortable : false, filterable: true, editable: true, renderCell: (params) => {

                    const id = params.row.id;
                    const userId = params.row.userId;

                    if (params.value) {

                        //params.value = "11__고용범__1634696828761" 꼴;

                        const name = params.value.split("__")[1];
                        const time = params.value.split("__")[2];
                        const date = new Date(+time);

                        //datestring으로 ~월 ~일 ~시 ~분 꼴로 만들기
                        const dateString = `${date.getMonth() + 1}/${date.getDate()}일 ${date.getHours() < 10 ? "0" + date.getHours() : date.getHours()}:${date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()}`;

                        return (
                            <span>
                                {name} {dateString} &nbsp; 
                                <Button variant="soft" size="sm" color="neutral" 
                                sx={{
                                    marginLeft : "30px"
                                }}
                                onClick={(e: any) => {
                                    submitCancel(id, params.field);
                                }}
                                >
                                    취소하기
                                </Button>
                            </span>
                        )
                    } else {
                        return (
                            <Button variant="soft" size="sm" color="neutral"
                                onClick={(e: any) => {
                                    submitCheck(id, params.field);
                                }}
                            >
                                <BlockIcon />
                            </Button>
                        )
                    }

                }
            },
            {
                field: 'cleanAfterSeat', headerName: '이동할 자리 치우기', width: 120, sortable : false, filterable: true, editable: true, renderCell: (params) => {

                    const id = params.row.id;
                    const userId = params.row.userId;

                    if (params.value) {

                        //params.value = "11__고용범__1634696828761" 꼴;

                        const name = params.value.split("__")[1];
                        const time = params.value.split("__")[2];
                        const date = new Date(+time);

                        //datestring으로 ~월 ~일 ~시 ~분 꼴로 만들기
                        const dateString = `${date.getMonth() + 1}/${date.getDate()}일 ${date.getHours() < 10 ? "0" + date.getHours() : date.getHours()}:${date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()}`;

                        return (
                            <span>
                                {name} {dateString} &nbsp; 
                                <Button variant="soft" size="sm" color="neutral" 
                                sx={{
                                    marginLeft : "30px"
                                }}
                                onClick={(e: any) => {
                                    submitCancel(id, params.field);
                                }}
                                >
                                    취소하기
                                </Button>
                            </span>
                        )
                    } else {
                        return (
                            <Button variant="soft" size="sm" color="neutral"
                                onClick={(e: any) => {
                                    submitCheck(id, params.field);
                                }}
                            >
                                <BlockIcon />
                            </Button>
                        )
                    }

                }
            },
            {
                field: 'movefile', headerName: '학생 파일 이동', width: 120, sortable : false, filterable: true, editable: true, renderCell: (params) => {

                    const id = params.row.id;
                    const userId = params.row.userId;

                    if(params.value === "-"){
                        return "-"
                    }

                    if (params.value) {

                        //params.value = "11__고용범__1634696828761" 꼴;

                        const name = params.value.split("__")[1];
                        const time = params.value.split("__")[2];
                        const date = new Date(+time);

                        //datestring으로 ~월 ~일 ~시 ~분 꼴로 만들기
                        const dateString = `${date.getMonth() + 1}/${date.getDate()}일 ${date.getHours() < 10 ? "0" + date.getHours() : date.getHours()}:${date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()}`;

                        return (
                            <span>
                                {name} {dateString} &nbsp; 
                                <Button variant="soft" size="sm" color="neutral" 
                                sx={{
                                    marginLeft : "30px"
                                }}
                                onClick={(e: any) => {
                                    submitCancel(id, params.field);
                                }}
                                >
                                    취소하기
                                </Button>
                            </span>
                        )
                    } else {
                        return (
                            <Button variant="soft" size="sm" color="neutral"
                                onClick={(e: any) => {
                                    submitCheck(id, params.field);
                                }}
                            >
                                <BlockIcon />
                            </Button>
                        )
                    }

                }
            },
            {
                field: 'finishMovingSeat', headerName: '자리이동 완료', width: 120, sortable : false, filterable: true, editable: true, renderCell: (params) => {

                    const id = params.row.id;
                    const userId = params.row.userId;

                    if (params.value) {

                        //params.value = "11__고용범__1634696828761" 꼴;

                        const name = params.value.split("__")[1];
                        const time = params.value.split("__")[2];
                        const date = new Date(+time);

                        //datestring으로 ~월 ~일 ~시 ~분 꼴로 만들기
                        const dateString = `${date.getMonth() + 1}/${date.getDate()}일 ${date.getHours() < 10 ? "0" + date.getHours() : date.getHours()}:${date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()}`;

                        return (
                            <span>
                                {name} {dateString} &nbsp; 
                                <Button variant="soft" size="sm" color="neutral" 
                                sx={{
                                    marginLeft : "30px"
                                }}
                                onClick={(e: any) => {
                                    submitCancel(id, params.field);
                                }}
                                >
                                    취소하기
                                </Button>
                            </span>
                        )
                    } else {
                        return (
                            <Button variant="soft" size="sm" color="neutral"
                                onClick={(e: any) => {
                                    submitCheck(id, params.field);
                                }}
                            >
                                <BlockIcon />
                            </Button>
                        )
                    }

                }
            },
            {
                field: 'realChange', headerName: '좌석표에 반영', width: 120, sortable : false, filterable: true, editable: true, renderCell: (params) => {

                    const id = params.row.id;
                    const userId = params.row.userId;

                    if (params.value) {

                        //params.value = "11__고용범__1634696828761" 꼴;

                        const name = params.value.split("__")[1];
                        const time = params.value.split("__")[2];
                        const date = new Date(+time);

                        //datestring으로 ~월 ~일 ~시 ~분 꼴로 만들기
                        const dateString = `${date.getMonth() + 1}/${date.getDate()}일 ${date.getHours() < 10 ? "0" + date.getHours() : date.getHours()}:${date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()}`;

                        return (
                            <span>
                                {name} {dateString}
                            </span>
                        )
                    } else {
                        return (
                            <Button variant="soft" size="sm" color="neutral"
                                onClick={(e: any) => {

                                    if(!window.confirm("좌석표에 반영하시겠습니까?")){
                                        return;
                                    }

                                    submitCheck(id, params.field, userId);
                                }}
                            >
                                반영하기
                            </Button>
                        )
                    }

                }
            },
            {
                field: 'finalCheck', headerName: "관리자 확인", width: 100, renderCell: (params) => {

                    const id = params.row.id;
                    const userId = params.row.userId;

                    const userName = props.user.name;

                    if (params.value) {

                        //params.value = "11__고용범__1634696828761" 꼴;

                        const name = params.value.split("__")[1];
                        const time = params.value.split("__")[2];
                        const date = new Date(+time);

                        //datestring으로 ~월 ~일 ~시 ~분 꼴로 만들기
                        const dateString = `${date.getMonth() + 1}/${date.getDate()}일 ${date.getHours() < 10 ? "0" + date.getHours() : date.getHours()}:${date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()}`;

                        return (
                            <span>
                                {name} {dateString}
                            </span>
                        )
                    } else if (!props.user.todoistApiKey) {
                        return (
                            <div>
                                관리자 권한 필요
                            </div>
                        )
                    } else {
                        return (
                            <Button variant="soft" size="sm" color="success"
                                onClick={(e: any) => {
                                    submitCheck(id, params.field);
                                }}
                            >
                                완료시키기
                            </Button>
                        )
                    }
                }
            },
            {
                field : "justForFilter", headerName : "필터", width : 2, filterable : true
            }
        ]);



    const [loading, setLoading] = useState(false);

    const onchange = async (e: any, value: any) => {
        if (!users) {
            return;
        }

        

        
        setSelectedUser(value);
    }

    useEffect(() => {

        if (selectedUser) {
            setDisabled3(false);
        } else {
            setDisabled3(true);
        }

    }, [selectedUser]);


    const notify1 = () => toast.success("삭제 성공!", {
        position: "bottom-right",
        autoClose: 2500,
        hideProgressBar: true,
        theme: "dark"
    });

    const notify2 = () => toast.success("업로드 성공!", {
        position: "bottom-right",
        autoClose: 2500,
        hideProgressBar: true,
        theme: "colored"
    });

    const notify3 = () => toast.success("수정 성공!", {
        position: "bottom-right",
        autoClose: 2500,
        hideProgressBar: true,
        theme: "colored"
    });

    const notify4 = () => toast.success("재전송 성공!", {
        position: "bottom-right",
        autoClose: 2500,
        hideProgressBar: true,
        theme: "colored"
    });

    useEffect(() => {

        if (selectedRow) {
            setDisabled(false);
        } else {
            setDisabled(true);
        }

    }, [selectedRow]);

    useEffect(() => {

        if(props.user){

            

            const newColumns : any = columns;

            newColumns.forEach((each : any) => {
                if(each.field === "afterLocation"){
                    each.valueOptions = [...totalLocationData.filter((each) => {
                        if(each.english === "total"){
                            return false;
                        }
    
                        if(!props.user){
                            return true;
                        }
    
                        if(each.academy.includes(props.user.academy)){
                            return true;
                        }
    
                        return false;
                    }).map((each) => {

                        
    
                        return {
                            value : each.korean,
                            label : each.korean
                        }
                    }), {value : "-", label : "지점 동일"}]; 
                }
            })

            setColumns([...newColumns]);

        }

    }, [props.user]);

    useEffect(() => {

        const totalFilter = [""];

        totalLocationData.forEach((each) => {

            if (each.english === "total") {
                return;
            }

            totalFilter.push(each.korean);
        });

        const newFilterModel = filterModel;

        newFilterModel.items.forEach((each: any) => {
            if (each.id === 3) {
                each.value = totalFilter;
            }
        })

        setFilterModel({ ...newFilterModel });

    }, []);



    useEffect(() => {

        getNewTodoList();

    }, []);

    useEffect(() => {

        
        async function start() {

            var token = "";

            if (window.electron) {
                token = await window.electron.sendMessageApi.getToken();
            }

            fetch("https://peetsunbae.com/dashboard/avatar/change/users", {
                method: "GET",
                headers: { "Authorization": token },
                credentials: "include",
            }).then((response: any) => {
                response.json()
                    .then((result: any) => {
                        
                        const rows: any = [];
                        result.data.forEach((each: any, index: number) => {
                            var data: any = {};
                            data.id = each.id;
                            data.label = `${each.name} (${each.location})`;
                            rows.push(data);
                        })
                        setUsers([...rows]);

                    })
            })
        }

        start();

    }, []);

    const submit = async () => {

        if (!selectedUser) {
            return;
        }

        const userId = selectedUser.id;

        if(!userId) {
            return;
        }

        try{

            setLoading1(true);

            const response = await fetch("https://peetsunbae.com/dashboard/avatar/change/seat", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify({
                    userId : userId
                })
            });

            const result = await response.json();

            

            if(result.message === "success"){

                getNewTodoList();
                setSelectedUser(null);
                setLoading1(false);
            }

        }catch(e){
            
        }

    }

    const submitCheck = async (id: number, column: string, userId = 0) => {

        if (!id || !column) {
            return;
        }

        try {

            setBtnLoading(true);

            const response = await fetch("https://peetsunbae.com/dashboard/avatar/change/submitcheck", {
                method: "POST",
                credentials: "include",
                headers: {
                    "content-type": "application/json"
                },
                body: JSON.stringify({
                    id, userId, column
                })
            });

            const result = await response.json();

            if (result.message === "success") {
                getNewTodoList();
                setBtnLoading(false);
            }

        } catch (e) {
            
        }

    }

    const submitCancel = async (id: number, column: string) => {

        if (!id || !column) {
            return;
        }

        try {

            setBtnLoading(true);

            const response = await fetch("https://peetsunbae.com/dashboard/avatar/change/submitcancel", {
                method: "POST",
                credentials: "include",
                headers: {
                    "content-type": "application/json"
                },
                body: JSON.stringify({
                    id, column
                })
            });

            const result = await response.json();

            if (result.message === "success") {
                getNewTodoList();
                setBtnLoading(false);
            }

        } catch (e) {
            
        }

    }

    const getNewTodoList = async () => {

        try {

            const response = await fetch("https://peetsunbae.com/dashboard/avatar/change/seat", {
                method: "GET",
                credentials: "include",
            });

            const result = await response.json();

            if (result.message === "success") {
                

                const data = result.data;

                console.log(data);
                const seatList = result.seatList;

                const newRows: any = [];

                data.forEach((each: any) => {

                    const oneRow: any = {};

                    oneRow.id = each.id;
                    oneRow.userId = each.userId;
                    oneRow.location = each.previousLocation;
                    if(!oneRow.location){
                        oneRow.location = "-";
                    }
                    oneRow.name = each.name;
                    const createdAtDate = new Date(each.createdAt);
                    //datestring으로 ~/~ ~:~ 꼴로 만들기
                    const createdAtDateString = `${createdAtDate.getMonth() + 1}/${createdAtDate.getDate()} ${createdAtDate.getHours() < 10 ? "0" + createdAtDate.getHours() : createdAtDate.getHours()}:${createdAtDate.getMinutes() < 10 ? "0" + createdAtDate.getMinutes() : createdAtDate.getMinutes()}`;
                    oneRow.createdAt = createdAtDateString;
                    oneRow.etc = each.etc;
                    oneRow.previousSeat = each.previousSeat;
                    oneRow.afterSeat = each.afterSeat;
                    oneRow.exitSeatDate = each.exitSeatDate;
                    oneRow.movingDate = each.movingDate;
                    oneRow.tellStudent = each.tellStudent;
                    oneRow.cleanAfterSeat = each.cleanAfterSeat;
                    oneRow.finishMovingSeat = each.finishMovingSeat;
                    oneRow.seatPhoto = each.seatPhoto;
                    oneRow.realChange = each.realChange;
                    oneRow.finalCheck = each.finalCheck;
                    oneRow.movefile = each.movefile;
                    oneRow.makeprint = each.makeprint;



                    oneRow.afterSeatOwner = each.afterSeatOwnerName;

                    if(!oneRow.afterSeatOwner){
                        oneRow.afterSeatOwner = "[자동 입력]";
                    }


                    if(each.finalCheck){
                        oneRow.justForFilter = "완료됨";
                    }else{
                        oneRow.justForFilter = "미완료";
                    }

                    oneRow.afterLocation = each.afterLocation;

                    if(!oneRow.afterLocation){
                        oneRow.afterLocation = "-";
                    }

                    //지점이 동일하면
                    if(!each.afterLocation){
                        oneRow.movefile = "-";
                        oneRow.makeprint = "-";
                    }


                    newRows.push(oneRow);

                })


                setRows([...newRows]);
            }

        } catch (e) {
            
        }

    }


    const handleEditCommit = React.useCallback(
        async (newRow: GridRowModel, old: any) => {


            if(newRow.justForFilter === "완료됨"){
                alert("완료된 이후에는 수정이 불가능합니다.");
                return;
            }


            var field = "";


            

            for (const [key, value] of Object.entries(newRow)) {
                if (value !== old[key]) {
                    field = key;
                }
            }

            const value = newRow[field] ? newRow[field] : null;
            const id = newRow.id;
            const userId = newRow.userId;

            
            
            
            
            

            if (!field) {
                
                return newRow;
            }

            if (!id) {
                
                return newRow;
            }

            const data = {
                value,
                id,
                userId,
                field
            }

            

            try {

                const response = await fetch("https://peetsunbae.com/dashboard/avatar/change/seat", {
                    method: "PATCH",
                    credentials: "include",
                    headers: {
                        "content-type": "application/json"
                    },
                    body: JSON.stringify(data)
                });

                const result = await response.json();

                if (result.message === "success") {
                    getNewTodoList();
                }

            } catch (e) {
                
            }

            return newRow;

        }, []
    );

    const handleProcessRowUpdateError = React.useCallback((error: Error) => {
        
        alert(error.message);
    }, []);

    const deleteRow = async () => {

        const id = selectedRow.sqlId;

        if (!id) {
            return;
        }

        try {

            if (!window.confirm("정말로 삭제하시겠습니까?")) {
                return;
            }

            setBtnLoading(true);

            const response = await fetch("https://peetsunbae.com/dashboard/avatar/change/seat", {
                method: "DELETE",
                credentials: "include",
                headers: {
                    "content-type": "application/json"
                },
                body: JSON.stringify({
                    id
                })
            });

            const result = await response.json();

            if (result.message === "success") {
                notify1();
                getNewTodoList();
                setBtnLoading(false);
            }

        } catch (e) {
            
        }

    }



    const handleAlignmentChange = (event: React.MouseEvent<HTMLElement>, newAlignment: string | null) => {

        if (!newAlignment) {
            return;
        }

        setAlignment(newAlignment);

        //filtermodel중 id가 2인 것을 찾아서 newAlignment가 incomplete면 "미완료", total이면 ""로 바꾸기

        const newFilterModel = filterModel;

        newFilterModel.items.forEach((each : any) => {
            if(each.id === 2){
                if(newAlignment === "incomplete"){
                    each.value = "미완료";
                }else{
                    each.value = "";
                }
            }
        })

        setFilterModel({...newFilterModel});

    }

    const handleAlignmentChange2 = (event: React.MouseEvent<HTMLElement>, newAlignment: string | null) => {

        if (!newAlignment) {
            return;
        }

        setAlignment2(newAlignment);

        //filtermodel중 id가 2인 것을 찾아서 newAlignment가 incomplete면 "미완료", total이면 ""로 바꾸기

        const newFilterModel = filterModel;

        // newFilterModel.items.forEach((each : any) => {
        //     if(each.id === 3){
        //         if(newAlignment === "total"){
        //             each.value = ["", "강남점", "대치점", "대치3층", "대치6층"];
        //         }else if(newAlignment === "gangnam"){
        //             each.value = ["강남점"];
        //         }else if(newAlignment === "daechi"){
        //             each.value = ["대치점"];
        //         }else if(newAlignment === "daechi2"){
        //             each.value = ["대치3층"];
        //         }else if(newAlignment === "daechi3"){
        //             each.value = ["대치6층"];
        //         }
        //     }
        // })

        totalLocationData.forEach((each) => {

            if(each.english === newAlignment){
             
                newFilterModel.items.forEach((each2 : any) => {
                    if(each2.id === 3){

                        const array : any = [];

                        if(newAlignment === "total"){

                            array.push("-");
                            //array.push(null);
                            // array.push(undefined);

                            totalLocationData.forEach((each3) => {

                                if(each3.english !== "total"){
                                    array.push(each3.korean);
                                }

                            });

                        }else{
                            array.push(each.korean);
                        }

                        each2.value = array;


                    }
                });

            }
        });

        setFilterModel({...newFilterModel});

    }

    const handleSearchTextChange = (e : any) => {
        
        setSearchText(e.target.value);

        const newFilterModel = filterModel;

        newFilterModel.items.forEach((each : any) => {
            if(each.id === 1){
                each.value = e.target.value;
            }
        })

        setFilterModel({...newFilterModel});

    }

    return (
        <div>
            <div style={{height : "24px"}}>

            </div>
            <div style={{
                display: "flex",
                justifyContent: "space-between",
            }}>
                <div style={{
                    display: "flex",
                }}>
                    <Autocomplete
                        onChange={onchange}
                        value={selectedUser}
                        disablePortal
                        id="combo-box-demo"
                        options={users}
                        sx={{ width: "250px", marginRight: "12px" }}
                        renderInput={(params) => <TextField {...params} placeholder="학생을 선택하세요" />}
                    />
                    <Button variant="soft" disabled={disabled3} onClick={submit} loading={loading1}>
                        추가하기
                    </Button>
                </div>
                <div>

                </div>
            </div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", marginBottom: "8px", marginTop: "24px" }}>
                <div>
                    <ToggleButtonGroup
                        color="primary"
                        value={alignment}
                        exclusive
                        onChange={handleAlignmentChange}
                        aria-label="Platform"
                        sx={{ marginRight: "36px" }}
                    >
                        <ToggleButton value="incomplete">미완료</ToggleButton>
                        <ToggleButton value="total">전체</ToggleButton>
                    </ToggleButtonGroup>

                    <ToggleButtonGroup
                        color="primary"
                        value={alignment2}
                        exclusive
                        onChange={handleAlignmentChange2}
                        aria-label="Platform"
                        sx={{ marginRight: "36px" }}
                    >
                        {/* <ToggleButton value="total">전체</ToggleButton>
                        <ToggleButton value="gangnam">강남점</ToggleButton>
                        <ToggleButton value="daechi">대치점</ToggleButton>
                        <ToggleButton value="daechi2">대치3층</ToggleButton>
                        <ToggleButton value="daechi3">대치6층</ToggleButton> */}
                        {
                            props.user && totalLocationData.filter((each) => each.academy.includes(props.user.academy)).map((each, index) => {
                                return (
                                    <ToggleButton key={index} value={each.english}>{each.korean}</ToggleButton>
                                )
                            })
                        }
                    </ToggleButtonGroup>

                    <TextField sx={{ fontSize: "24px", marginLeft : "12px" }} label="이름 검색" variant="standard" value={searchText} onChange={handleSearchTextChange} />
                </div>
                <div>
                    <Button variant="soft" size="sm" color="neutral" loading={deleteBtnLoading} disabled={disabled} style={{ marginRight: "12px" }}
                        onClick={(e: any) => {
                            if (!selectedRow) {
                                return;
                            }
                            setForImageUploadSelectedId(selectedRow.sqlId);
                            setImageUploadModalOpen(true);
                        }}
                    >
                        기존 좌석 청소 사진 업로드
                    </Button>
                    <Button variant="soft" size="sm" color="danger" loading={deleteBtnLoading} disabled={disabled} onClick={deleteRow}>
                        삭제하기
                    </Button>
                </div>
            </div>
            <div className={classes.root} style={{ height: 500, width: '100%', backgroundColor: "white", marginTop: "24px" }}>
                <DataGridPremium
                    filterModel={filterModel}
                    onFilterModelChange={(model) => {
                        
                        setFilterModel(model);
                    }}
                    slots={{ toolbar: GridToolbar }}
                    loading={loading}
                    density="compact"
                    columns={columns}
                    getCellClassName={(params: any) => {

                        if(params.value === "[자동 입력]"){
                            return "autoinput";
                        }
                        
                        return ""
                    }}
                    getRowClassName={(params: GridRowClassNameParams<any>) => {

                        if(params.row.justForFilter === "완료됨"){
                            return "completed";
                        }

                        return ""
                    }}
                    rows={rows}
                    processRowUpdate={handleEditCommit}
                    onProcessRowUpdateError={handleProcessRowUpdateError}
                    apiRef={apiRef}
                    initialState={{
                        pinnedColumns : { left : ["name"]}
                    }}
                    onRowSelectionModelChange={(newSelectionModel) => {
                        const data: any = apiRef.current.getSelectedRows();
                        if (!data) {
                            return;
                        }
                        
                        

                        

                        data.forEach((value: any, index: number) => {

                            const newSelectedInfo = {
                                sqlId: value.id,
                                name : value.name,
                                userId : value.userId
                            }

                            
                            setSelectedRow(newSelectedInfo);
                        })
                    }}
                />
            </div>



            <ImageUploadModal open={imageUploadModalOpen} handleClose={handleImageUploadModalClose} update={getNewTodoList} id={forImageUploadSelectedId} success={notify2} kind="change" />

            <ImageModal2
                open={open3}
                handleClose={() => { setOpen3(false) }}
                src={[imageSrc]}
            />

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={btnLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            

            <div style={{height : "32px"}}>

            </div>
            <RequestChange user={props.user} />

        </div>
    )

}

export default Change;